import Navbar from './components/layout/Navbar';
import AllRouter from './router/Router';

function App() {
  return (
    <div>
      <Navbar />
      <AllRouter />
    </div>
  );
}

export default App;
